import { apiRequest } from '@/core';
import { type CreateMemberPayload } from '@/slices/members/types';

export const createMemberRequest = async ({
  propertyId,
  member,
}: CreateMemberPayload) =>
  apiRequest<void>({
    endpoint: `api/members/${propertyId}/create`,
    method: 'POST',
    body: member,
  });
